import React from 'react';
import { Icon } from '../style';

export function TMSad(properties) {
  return (
    <Icon
      {...properties}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 60.95 60.95"
    >
      <defs>
        <linearGradient
          id="b62c1691-ccb0-4ebb-bc69-829600ec4fd4"
          x1="27.55"
          x2="28.87"
          y1="50.5"
          y2="55.42"
          gradientTransform="matrix(1 0 0 -1 0 82)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#3c2200" />
          <stop offset="1" stopColor="#7a4400" />
        </linearGradient>
        <linearGradient
          id="a64190a8-95d0-455e-a893-30af5292268e"
          x1="30.04"
          x2="30.04"
          y1="49.35"
          y2="45.03"
          gradientTransform="matrix(1 0 0 -1 0 82)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#3c2200" />
          <stop offset="1" stopColor="#512d00" />
        </linearGradient>
        <linearGradient
          id="b4a020ac-ecf0-4e25-8fed-41477ba039f1"
          x1="39.99"
          x2="39.99"
          y1="30.88"
          y2="26.61"
          xlinkHref="#a64190a8-95d0-455e-a893-30af5292268e"
        />
        <linearGradient
          id="e46e6742-67c2-4497-a525-0d2bfbc05509"
          x1="52.47"
          x2="51.16"
          y1="50.41"
          y2="55.32"
          xlinkHref="#b62c1691-ccb0-4ebb-bc69-829600ec4fd4"
        />
        <linearGradient
          id="bc555d54-0181-42b9-aa99-f26f73723820"
          x1="49.94"
          x2="49.94"
          y1="49.35"
          y2="45.03"
          xlinkHref="#a64190a8-95d0-455e-a893-30af5292268e"
        />
        <radialGradient
          id="e728890e-dcaf-460a-87ef-7badc144a33d"
          cx="-100.2"
          cy="314.5"
          r="1"
          gradientTransform="matrix(36.77 0 0 -36.77 3717.85 11590.41)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffe030" />
          <stop offset="1" stopColor="#ffb92e" />
        </radialGradient>
        <radialGradient
          id="b68c91c5-1bcb-42d1-8e9c-d78ca8e6d508"
          cx="-99.44"
          cy="312.74"
          r="1"
          gradientTransform="matrix(28.93 0 0 -28.93 2910.28 9073.61)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffea5f" />
          <stop offset="1" stopColor="#ffbc47" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="f8620e00-274f-48d2-b341-812199cc3339"
          cx="-43.03"
          cy="332.66"
          r="1"
          gradientTransform="matrix(1.2 4.14 2.68 -.77 -809.51 473.04)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#7a4400" />
          <stop offset="1" stopColor="#643800" />
        </radialGradient>
        <radialGradient
          id="af9cd6f0-3fb7-4e2b-8545-5040051be46a"
          cx="-43.03"
          cy="332.66"
          r="1"
          gradientTransform="matrix(1.2 4.14 2.68 -.77 -789.61 473.04)"
          xlinkHref="#f8620e00-274f-48d2-b341-812199cc3339"
        />
      </defs>
      <path
        fill="url(#e728890e-dcaf-460a-87ef-7badc144a33d)"
        d="M40 70.48A30.48 30.48 0 1 0 9.52 40 30.48 30.48 0 0 0 40 70.48Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#b68c91c5-1bcb-42d1-8e9c-d78ca8e6d508)"
        d="M40 70.48A30.48 30.48 0 1 0 9.52 40 30.48 30.48 0 0 0 40 70.48Z"
        opacity=".5"
        style={{ isolation: 'isolate' }}
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#b62c1691-ccb0-4ebb-bc69-829600ec4fd4)"
        d="M34.8 29.28c.32-1.18-.76-2.27-2.95-2.86a12.46 12.46 0 0 0-10 2.3c-.71.54 0 1.11.63.82a16.43 16.43 0 0 1 10.8-.28c1.39.55 1.52.02 1.52.02Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#f8620e00-274f-48d2-b341-812199cc3339)"
        d="M30 41.64c1.62 0 2.93-2 2.93-4.44s-1.27-4.44-2.93-4.44-2.94 2-2.94 4.44 1.36 4.44 2.94 4.44Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#a64190a8-95d0-455e-a893-30af5292268e)"
        d="M30 34.25c1.26 0 2.36 1.1 2.93 2.72 0-2.4-1.33-4.32-2.93-4.32s-2.86 1.92-2.9 4.35c.58-1.65 1.68-2.75 2.9-2.75Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="#643800"
        d="M27.22 58.36a.78.78 0 0 0 .65-.19 18.74 18.74 0 0 1 11.5-4.23h1.26a18.74 18.74 0 0 1 11.5 4.23.8.8 0 0 0 .65.19.34.34 0 0 0 .25-.51 15 15 0 0 0-12.88-7h-.3a15 15 0 0 0-12.88 7 .32.32 0 0 0 .25.51Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#b4a020ac-ecf0-4e25-8fed-41477ba039f1)"
        d="M27.22 58.36a.78.78 0 0 0 .65-.19 18.74 18.74 0 0 1 11.5-4.23h1.26a18.74 18.74 0 0 1 11.5 4.23.8.8 0 0 0 .65.19.34.34 0 0 0 .25-.51.87.87 0 0 1-.08-.14c-.25.14-.51.27-.8 0a16.49 16.49 0 0 0-12-5h-.34a16.46 16.46 0 0 0-12.06 5.07c-.26.29-.51.15-.76 0l-.06.1a.34.34 0 0 0 .29.48Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#e46e6742-67c2-4497-a525-0d2bfbc05509)"
        d="M45.2 29.28c-.32-1.18.76-2.27 2.95-2.86a12.46 12.46 0 0 1 10 2.3c.71.54 0 1.11-.63.82a16.43 16.43 0 0 0-10.8-.28c-1.39.55-1.52.02-1.52.02Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#af9cd6f0-3fb7-4e2b-8545-5040051be46a)"
        d="M49.94 41.64c1.62 0 2.94-2 2.94-4.44s-1.32-4.44-2.94-4.44S47 34.75 47 37.2s1.32 4.44 2.94 4.44Z"
        transform="translate(-9.52 -9.52)"
      />
      <path
        fill="url(#bc555d54-0181-42b9-aa99-f26f73723820)"
        d="M49.94 34.25c1.26 0 2.36 1.1 2.94 2.72 0-2.4-1.34-4.32-2.94-4.32S47.05 34.57 47 37c.58-1.65 1.69-2.75 2.94-2.75Z"
        transform="translate(-9.52 -9.52)"
      />
    </Icon>
  );
}
